import React from 'react';
import './inputtags.scss';

const InputTags = (props) => {
    const { tags, setTags, valueSearch, setValueSearch, placeholder, noClear } = props;

    const removeTags = indexToRemove => {
        if (tags) setTags([...tags.filter((_, index) => index !== indexToRemove)]);
    };

    const addTags = event => {
        if (event.target.value !== "") {
            if (!noClear && tags) {
                setTags([...tags, event.target.value]);
                setValueSearch("");
            }
        }
    };

    return (
        <div className="tags-input">
            {
                tags && tags?.length ? (
                    <ul id="tags">
                        {
                            tags.map((tag, index) => (
                                <li key={index} className="tag">
                                    <span className='tag-title'>{tag}</span>
                                    <span className='tag-close-icon'
                                        onClick={() => removeTags(index)}
                                    >
                                        x
                                    </span>
                                </li>
                            ))
                        }
                    </ul>

                ) : <></>
            }
            <input
                type="text"
                onKeyUp={e => {
                    e.preventDefault();
                    if (event.key === "Backspace" && valueSearch === "") {
                        let currentTags = tags || [];
                        currentTags.pop();
                        setTags([...currentTags]);
                    }
                    e.key === "Enter" ? addTags(e) : null
                }}
                onChange={(e) => {
                    e.preventDefault();
                    setValueSearch(e.target.value);
                }}
                placeholder={placeholder || "Search"}
                value={valueSearch}
            />
        </div>
    );
};

export default InputTags;